export const LIST_TYPE_PARENTHESES = 'parentheses'
export const LIST_TYPE_HEADING = 'numbered'
export const ATTR_LIST_TYPE = 'data-list-type'
export const ATTR_LIST_HEADING = 'data-list-heading'
export const ATTR_POWER_PASTE_STYLE = 'data-mce-style'
export const classes = {
  list_item_span: 'custom-list-item-span',
}
